import './ForgotPassword.scss';

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { WrappedErrorBoundary } from '../WrappedErrorBoundary';

const Timer = ({ setShowTimer, ttl }: { setShowTimer: (bool: boolean) => void; ttl: number }) => {
  const { t } = useTranslation();
  const [remain, setRemain] = useState(ttl);

  useEffect(() => {
    const interval = setInterval(() => {
      setRemain(remain - 1);

      if (remain <= 0) setShowTimer(false);
    }, 1000);

    return () => clearInterval(interval);
  }, [remain, setShowTimer, ttl]);

  return (
    <span>
      {remain} {t('authPages/forgotPassword/l-01')}
    </span>
  );
};

export default WrappedErrorBoundary(Timer);
